export default __webpack_public_path__ + "static/media/mujer_corriendo_Dashport.7b6b456c.webp";